import { z } from "zod";

export const UserTest = z.object({
  id: z.string(),
  email: z.string(),
});

export type UserTest = z.infer<typeof UserTest>;
